import { useForm } from 'react-hook-form'

import { yupResolver } from '@hookform/resolvers/yup'
import { TextInput } from '@ui/components/core/TextInput'
import { DynamicFormProps } from '@ui/interfaces'
import { SaveAndCancelButtons } from '@ui/pages/pipelinesWorkflow/components/DestinationForms/SaveAndCancelButtons'
import * as Yup from 'yup'

const schema = Yup.object({
  host: Yup.string().required('URL must be provided'),
  port: Yup.string().required('Port must be provided'),
  apiToken: Yup.string().required('API Token must be provided'),
}).required()

export default function Chronosphere(props: DynamicFormProps) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    defaultValues: {
      ...props.config,
    },
  })

  const { saveClick, cancelClick } = props

  return (
    <form onSubmit={handleSubmit(saveClick)}>
      {props.additionalInputs}
      <div>
        <TextInput
          label="Host*"
          placeholder="MY_COMPANY.chronosphere.io"
          disabled={props.disableInputs}
          register={register}
          name="host"
          error={errors['host']?.message}
        />
        <TextInput
          label="Port*"
          placeholder="443"
          disabled={props.disableInputs}
          register={register}
          name="port"
          error={errors['port']?.message}
        />
        <TextInput
          label="API Token*"
          placeholder="abcd1234"
          disabled={props.disableInputs}
          register={register}
          name="apiToken"
          error={errors['apiToken']?.message}
        />
        {props.submitButton ? props.submitButton : <SaveAndCancelButtons cancelClick={cancelClick} />}
      </div>
    </form>
  )
}
